import React from "react";
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin, FaEnvelope, FaPhone } from "react-icons/fa";

const footerStyle = {
  background: "#fff",
  color: "#333",
  padding: "40px 20px",
  textAlign: "center",
  fontSize: "16px",
  boxShadow: "0px -3px 10px rgba(0, 0, 0, 0.1)",
  position: "relative",
  bottom: 0,
  margin:"auto",
  width: "100%",
  maxWidth: "100%",
  boxSizing: "border-box",
  zIndex: 1000,
};

const linkStyle = {
  color: "#333",
  textDecoration: "none",
  margin: "0 15px",
  fontWeight: "500",
  transition: "color 0.3s ease-in-out",
};

const hoverEffect = {
  color: "#0b023d",
};

const iconStyle = {
  fontSize: "24px",
  margin: "0 10px",
  cursor: "pointer",
  transition: "transform 0.3s ease-in-out, color 0.3s ease-in-out",
};

const socialIconStyle = {
  display: "flex",
  justifyContent: "center",
  marginTop: "15px",
};

const contactStyle = {
  marginTop: "15px",
  fontSize: "14px",
};

/* Smooth Scroll Effect */
const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: "smooth" });
};

function Footer() {
  return (
    <footer style={footerStyle}>
      <p>&copy; 2026 BJP Odisha . All rights reserved.</p>

      {/* Navigation Links */}
      <ul style={{ listStyle: "none", padding: 0 }}>
        {["Home", "About Us", "Services", "Privacy Policy", "Terms of Service", "Contact Us"].map((item, index) => (
          <li key={index} style={{ display: "inline" }}>
            <a href="#home" style={linkStyle} onMouseEnter={(e) => (e.target.style.color = hoverEffect.color)} onMouseLeave={(e) => (e.target.style.color = "#333")}>
              {item}
            </a>
          </li>
        ))}
      </ul>

      {/* Contact Details */}
      <div style={contactStyle}>
        <p>
          <FaEnvelope /> Email: it.bjp.odisha@gmail.com | 
          <FaPhone /> Phone: +123 456 7890
        </p>
        <p>Address: Bhubaneswar,Odisha, India</p>
      </div>

      {/* Social Media Icons */}
      <div style={socialIconStyle}>
        {[FaFacebook, FaTwitter, FaInstagram, FaLinkedin].map((Icon, index) => (
          <Icon
            key={index}
            style={{ ...iconStyle }}
            onMouseEnter={(e) => {
              e.target.style.transform = "scale(1.2)";
              e.target.style.color = hoverEffect.color;
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = "scale(1)";
              e.target.style.color = "#333";
            }}
          />
        ))}
      </div>

      {/* Scroll to Top Button */}
      <button
        onClick={scrollToTop}
        style={{
          marginTop: "20px",
          padding: "10px 20px",
          background: "#0b023d",
          color: "#fff",
          border: "none",
          borderRadius: "5px",
          cursor: "pointer",
          transition: "background 0.3s ease-in-out",
        }}
        onMouseEnter={(e) => (e.target.style.background = "#1e1e73")}
        onMouseLeave={(e) => (e.target.style.background = "#0b023d")}
      >
        Scroll to Top
      </button>
    </footer>
  );
}

export default Footer;
